import { Component } from 'react'
import Modal from 'components/shared/Modal'
import ConditionalRender from 'components/shared/ConditionalRender'
import CircleOfWaiting from 'components/shared/CircleOfWaiting'

import style from './style'

const vidyardScriptId = 'vidyard-script'
const config = { clientId: 'drift.com' }


class VidyardModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isOpen: props.isOpen,
      isLoading: true
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ isOpen: !!props.isOpen })
  }

  createVidyardScript = () => {
    const script = document.createElement('script')
    script.id = vidyardScriptId
    script.src = '//app.vidyard.com/v1/embed.js'
    return script
  }

  onViyardScriptLoaded = () => {
    this.setState({ isLoading: false })
    this.createVidyardLibrary()
  }

  createVidyardLibrary = () => {
    const library = window.Vidyard.goVideo.createLibrary(this.embedElement, config)
    library.on('player:created', this.onPlayerCreated)
  }

  onPlayerCreated = ({ embed_codes }) => {
    const { onVideoInserted, insertFull = false } = this.props
    if (onVideoInserted) {
      if (insertFull) {
        onVideoInserted(embed_codes)
      } else {
        onVideoInserted(embed_codes.sharing_page)
      }
    }
    this.setState({ isOpen: false })
  }

  loadVidyardScript = () => {
    const script = this.createVidyardScript()
    script.onload = this.onViyardScriptLoaded

    document.body.appendChild(script)
  }

  removeVidyardScript = () => {
    const elt = document.getElementById(vidyardScriptId)
    if (!!elt)
      elt.remove()
  }

  tryLoadVidyardScript = () => {
    if (document.getElementById(vidyardScriptId))
      this.removeVidyardScript()
    this.loadVidyardScript()
  }

  closeModal = () => {
    const tryInvokeOnClosed = () => {
      const { onClosed } = this.props
      onClosed && onClosed()
    }
    this.setState({ isOpen: false }, tryInvokeOnClosed)
  }

  captureEmbedElement = (element) => {
    this.embedElement = element
  }

  render() {
    const { isOpen, isLoading } = this.state
    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.tryLoadVidyardScript}
        onRequestClose={this.closeModal}
        className="vidyard-modal-content">
        <ConditionalRender condition={isLoading}>
          <div className="vidyard-modal-loader">
            <CircleOfWaiting />
          </div>
        </ConditionalRender>
        <div ref={this.captureEmbedElement} />
      </Modal>
    )
  }
}

export default VidyardModal



// WEBPACK FOOTER //
// ./src/scripts/components/VidyardModal/index.js